import { Tooltip } from 'antd';
import SVGPureIcon from './index';
import "./index.scss";

export default function SVGButton({
  name,
  onClick,
  active = false,
  size = 40,
  className = '',
  iconClass = '',
  style = null,
  tooltip = '',
  ...props
}) {
  const handleClick = evt => {
    evt.preventDefault();

    onClick?.();
  };

  const button = (
    <a
      href="#nogo"
      className={[
        'group cursor-pointer flex items-center svg-pure-button text-center',
        'text-button-normal hover:text-button-hover active:opacity-50',
        { '!text-[#222222]': active },
        className,
      ]}
      style={style}
      onClick={handleClick}
      {...props}
    >
      <SVGPureIcon name={name} size={size} iconClass={iconClass} />
    </a>
  );

  return tooltip ? (
    <Tooltip title={tooltip} destroyTooltipOnHide={true} transitionName="">
      {button}
    </Tooltip>
  ) : (
    button
  );
};
